import { render, staticRenderFns } from "./RoutePathSwitch.vue?vue&type=template&id=60833438&"
import script from "./RoutePathSwitch.vue?vue&type=script&lang=js&"
export * from "./RoutePathSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports